import classNames from "classnames";
import styles from "./PreOrderCodeInput.module.css";

export default function PreOrderCodeInput({
  value,
  onChange,
  ref = undefined,
}) {
  return (
    <div
      className={classNames(
        "d-flex align-items-center column-gap-1",
        styles.box
      )}
    >
      <input
        className={styles.input}
        value={value}
        onChange={e => {
          const value = e.target.value;
          const matches = value.match(/\d+/g);
          onChange(matches ? matches.join("") : "");
        }}
        ref={ref}
      />
      <span className={styles.span}>pre</span>
    </div>
  );
}
